import { LotteryBottle } from './components'
import { useGetLotteryBottle } from './hooks/useGetLotteryBottle'

interface Props {
  className?: string
}

const BottleOnMainPage: React.FC<Props> = ({ className }) => {
  const { lotteryBottle } = useGetLotteryBottle()

  return <div className={className}>{lotteryBottle && <LotteryBottle {...lotteryBottle} />}</div>
}

export default BottleOnMainPage
